<div class="flex justify-center items-start space-x-4">
  <img
    class="h-40 w-60 object-contain"
    src="images/element-21.png"
    alt="element"
  />
  <div class="flex flex-col mt-5">
    <label class="text-xl font-bold text-gray-900 mt-5">
      เปิดใช้งานระบบชำระเงิน
    </label>
    <label class="text-sm text-gray-600 mt-1 text-center">
      อัตโนมัติเพื่อ เข้า-ออก ได้ทันที
    </label>
  </div>
</div>
<div class="p-5 mt-7">
  <label class="block text-gray-700 text-base mb-2 font-bold">
    เพื่อใช้บริการต่อไปนี้ คุณต้องเปิดการใช้งานการชำระเงินอัตโนมัติ
    สำหรับป้ายทะเบียนของคุณ :
  </label>
  <label class="block text-gray-700 text-base mb-2 font-normal">
    - ไม่มีความยุ่งยากในการเข้าและออก !
  </label>
  <label class="block text-gray-700 text-base mb-2 font-normal">
    - ไม่ต้องเสียเวลาในการยืนรอคิวที่เครื่องรับชำระเงินอีกต่อไป !
  </label>
  <label class="block text-gray-700 text-base mb-2 font-normal">
    - สามารถใช้ได้หลังออกจากสถานที่แล้ว !
  </label>
</div>
<div
  class="flex justify-between items-center p-4 shadow-sm w-full mx-auto"
>
  <label htmlFor="toggle-payment" class="text-ls font-medium text-gray-900">
    เปิดใช้งานระบบชำระเงินอัตโนมัติ
  </label>

  <label
    htmlFor="toggle-payment"
    class="relative inline-block w-12 h-6 cursor-pointer"
  >
    <input type="checkbox" id="toggle-payment" class="sr-only peer" />
    <div
      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-green-600 transition-colors duration-300"
    ></div>
    <div
      class="absolute top-0.5 left-0.5 bg-white w-5 h-5 rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-6"
    ></div>
  </label>
</div>


<div
  class="flex justify-between items-center p-4 shadow-sm w-full mx-auto mt-2"
>
  <label htmlFor="toggle-payment" class="text-ls font-medium text-gray-900">
    เปิดใช้งานการเข้าและออกอัตโนมัติ
  </label>

  <label
    htmlFor="toggle-payment"
    class="relative inline-block w-12 h-6 cursor-pointer"
  >
    <input type="checkbox" id="toggle-payment" class="sr-only peer" />
    <div
      class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-green-600 transition-colors duration-300"
    ></div>
    <div
      class="absolute top-0.5 left-0.5 bg-white w-5 h-5 rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-6"
    ></div>
  </label>
</div>
<footer class="px-4 pb-6 mt-7">
  <div class="flex flex-col space-y-5">
    <button
      class="w-full rounded-xl py-2.5 bg-green-500 text-white text-xl shadow-sm"
    >
      บันทึกข้อมูล
    </button>
  </div>
</footer>
